import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Menu, Icon, Label, Image } from 'semantic-ui-react';

import * as commonVar from 'libs/commonVar';

import classNames from 'classnames/bind';
import styles from './MyPageMenu.css';
const cx = classNames.bind(styles);

class MyPageMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { activeItem, onClickItem, serviceNo, originalServiceNo } = this.props;
    return (
      <div className={cx('mypage-menu-box')}>
        <Menu vertical className={cx('mypage-menu')}>
          {serviceNo === originalServiceNo && (
            <Menu.Item className="mypage-item" name="profile" active={activeItem === 'profile'} onClick={onClickItem}>
              <div className={cx('icon profile')} />
              {defineMessages(formatMessage({ id: 'MyPageMenu_1', defaultMessage: '내 정보' }))}
            </Menu.Item>
          )}
          <Menu.Item className="mypage-item" name="smtp" active={activeItem === 'smtp'} onClick={onClickItem}>
            <div className={cx('icon smtp')} />
            SMTP
          </Menu.Item>
          {commonVar.isEdu === 1 && (
            <Menu.Item className="mypage-item" name="edu" active={activeItem === 'edu'} onClick={onClickItem}>
              <div className={cx('icon edu')} />
              {defineMessages(formatMessage({ id: 'MyPageMenu_10', defaultMessage: '교육설정' }))}
            </Menu.Item>
          )}
          {/* {commonVar.isEdu === 1 && (
            <Menu.Item
              className={cx('mypage-item', 'lower')}
              name="edu/quiz"
              active={activeItem === 'edu/quiz'}
              onClick={onClickItem}>
              {defineMessages(formatMessage({ id: 'Edu_57', defaultMessage: '퀴즈' }))}
            </Menu.Item>
          )} */}
          {commonVar.isDeclare === 1 && (
            <Menu.Item className="mypage-item" name="declare" active={activeItem === 'declare'} onClick={onClickItem}>
              <div className={cx('icon declare')} />
              {defineMessages(formatMessage({ id: 'MyPageMenu_9', defaultMessage: '신고설정' }))}
            </Menu.Item>
          )}
          {/* <Menu.Item
            className="mypage-item"
            name="examtemplate"
            active={activeItem === 'examtemplate'}
            onClick={onClickItem}>
            <div className={cx('icon template')} />
            {defineMessages(formatMessage({ id: 'MyPageMenu_2', defaultMessage: '훈련 템플릿' }))}
          </Menu.Item> */}

          {/* <Menu.Item
            className={cx('mypage-item', 'lower')}
            name="examtemplate/examtemplatePhishing"
            active={activeItem === 'examtemplate/examtemplatePhishing'}
            onClick={onClickItem}>
            {defineMessages(formatMessage({ id: 'MyPageMenu_7', defaultMessage: '피싱 페이지' }))}
          </Menu.Item> */}

          {commonVar.isGs !== 1 && (
            <Menu.Item className="mypage-item" name="license" active={activeItem === 'license'} onClick={onClickItem}>
              <div className={cx('icon license')} />
              {defineMessages(formatMessage({ id: 'MyPageMenu_3', defaultMessage: '라이센스' }))}
            </Menu.Item>
          )}
          {/* <Menu.Item className="mypage-item" name="qna" active={activeItem === 'qna'} onClick={onClickItem}>
          문의사항
          <Icon name="comments outline" />
        </Menu.Item> */}
          {serviceNo === originalServiceNo && (
            <Menu.Item className="mypage-item" name="share" active={activeItem === 'share'} onClick={onClickItem}>
              <div className={cx('icon share')} />
              {defineMessages(formatMessage({ id: 'MyPageMenu_4', defaultMessage: '서비스 공유' }))}
            </Menu.Item>
          )}
          {/* {localStorage.getItem('language') === 'ko' && (
            <Menu.Item className="mypage-item" name="release" active={activeItem === 'release'} onClick={onClickItem}>
              <div className={cx('icon release')} />
              {defineMessages(formatMessage({ id: 'MyPageMenu_6', defaultMessage: '릴리즈 노트' }))}
            </Menu.Item>
          )} */}
          {/* 탈퇴 */}
        </Menu>
        <div className={cx('mypage-support')}>
          <div className={cx('mypage-support-title')}>
            {defineMessages(formatMessage({ id: 'MyPageMenu_5', defaultMessage: '문의하기' }))}
          </div>
          {commonVar.isJapan === 1 ? (
            <a href="mailto:support-m@jsecurity.co.jp" className={cx('support-mail-link')}>
              <Label>
                <Image className={cx('support-icon')} src="/img/setting/mail.png" /> support-m@jsecurity.co.jp
              </Label>
            </a>
          ) : (
              <a href="mailto:mudfix@jiran.com" className={cx('support-mail-link')}>
                <Label>
                  <Image className={cx('support-icon')} src="/img/setting/mail.png" /> mudfix@jiran.com
              </Label>
              </a>
            )}
        </div>
      </div>
    );
  }
}

MyPageMenu.propTypes = {
  activeItem: PropTypes.string
};
MyPageMenu.defaultProps = {
  activeItem: 'profile'
};

export default injectIntl(MyPageMenu);



// WEBPACK FOOTER //
// ./src/script/components/mypage/MyPageMenu.js